import StandardPolicyCancel from "@/components/app/policyCancel/cancellations/StandardPolicyCancel.vue";
import OrantaPolicyCancel from "@/components/app/policyCancel/cancellations/OrantaPolicyCancel.vue";
import KnajzaPolicyCancel from "@/components/app/policyCancel/cancellations/KnajzaPolicyCancel.vue";
import StatementPolicyCancel from "@/components/app/policyCancel/cancellations/StatementPolicyCancel.vue";
import VusoPolicyCancel from "@/components/app/policyCancel/cancellations/VusoPolicyCancel.vue";
import PzuPolicyCancel from "@/components/app/policyCancel/cancellations/PzuPolicyCancel.vue";
import IngoPolicyCancel from "@/components/app/policyCancel/cancellations/IngoPolicyCancel.vue";
import TasPolicyCancel from "@/components/app/policyCancel/cancellations/TasPolicyCancel.vue";

export default {
  StandardPolicyCancel,
  OrantaPolicyCancel,
  KnajzaPolicyCancel,
  StatementPolicyCancel,
  VusoPolicyCancel,
  PzuPolicyCancel,
  IngoPolicyCancel,
  TasPolicyCancel
};
